import React from 'react';
import PropTypes from 'prop-types';

import useDismissiblePersistent from '../../../../../../hooks/useDismissiblePersistent';
import SpecialtyAlbumGreetingModal from './modal';

const propTypes = {
  enabled: PropTypes.bool.isRequired,
  albumId: PropTypes.string.isRequired,
};

const SpecialtyAlbumGreetingDismissiblePersistent = ({
  enabled,
  albumId,
  ...props
}) => {
  const { visible, onDismiss } = useDismissiblePersistent(
    `SPECIALTY_ALBUM_${albumId}_GREETING_DISMISSIBLE`,
  );

  if (!visible || !enabled) {
    return null;
  }

  return (
    <SpecialtyAlbumGreetingModal
      forceOpen
      onClose={onDismiss}
      albumId={albumId}
      {...props}
    />
  );
};

SpecialtyAlbumGreetingDismissiblePersistent.propTypes = propTypes;

export default SpecialtyAlbumGreetingDismissiblePersistent;
